import FoodCardItem from "./FoodCardItem"
import PropTypes from 'prop-types';

const FoodCardList = ({ items = [] }) => {
    return (
        <>
            {
                items.map((item, index) => {
                    return (<FoodCardItem key={'fci_' + index} name={item.name} img={item.img} />);
                })
            }

        </>
    )
}

FoodCardList.propTypes = {
    items: PropTypes.array
}

export default FoodCardList
